export const GradeLevelOptions = [
    "Freshman",
    "Sophomore",
    "Junior",
    "Senior",
    "5th/6th Year",
    "Grad Student",
];
export const GradeOptions = ["N/A", "A", "B", "C", "D", "F", "CR", "NC", "W"];
export const CourseTypeOptions = [
    "Elective",
    "General Ed",
    "Major (Support)",
    "Major (Required)",
];
//# sourceMappingURL=Review.js.map